// Iovation blackbox fingerprinting

export const getBlackBox = (): string => window.IGLOO.getBlackbox().blackbox;

export default getBlackBox;
